const useSecondaryCTACopy = secondaryCTA => {
  if (!secondaryCTA || !secondaryCTA?.label) {
    return undefined;
  }
  return {
    id: secondaryCTA?.i18nId || 'createAccountCta.signIn',
    defaultMessage: secondaryCTA?.label
  };
};
export { useSecondaryCTACopy as default };
//# sourceMappingURL=useSecondaryCTACopy.js.map
